import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate, useLocation, useParams } from "react-router-dom"
import ModalContext from "./ModalContext"
import NotificationContext from "./NotificationContext"
import { strToSnakeCase } from "../js/string_utils"
import { DebugManager } from "./DebugManager"
import { RightsManager } from "./RightsManager"

function withHooks(Component) {
  return function ComponentWithHooks(props) {
    // console.log(`withHooks called by ${Component.displayName || Component.name || "Unknown Component"}`)

    const { t, i18n } = useTranslation()
    const changeLanguage = (lng) => {
      // console.log("changeLanguage", lng)
      i18n.changeLanguage(lng)
    }

    const navigate = useNavigate()
    const location = useLocation()
    const params = useParams()
    const nav = (navParams) => {
      let url = ""
      if (navParams["url"] !== undefined) {
        url += navParams["url"]
      } else {
        if (navParams["prefix"] !== undefined) {
          url += "/" + strToSnakeCase(navParams["prefix"])
        }
        if (navParams["entitiesType"] !== undefined) {
          url += "/" + strToSnakeCase(navParams["entitiesType"])
        }
        if (navParams["actionName"] !== undefined) {
          url += "/" + navParams["actionName"]
        }
        if (navParams["functionName"] !== undefined) {
          url += "/" + navParams["functionName"]
        }
        if (navParams["entityId"] !== undefined) {
          url += "/" + navParams["entityId"]
        }
      }

      let state = {}
      if (navParams["referrerUrl"] !== undefined) {
        state["referrerUrl"] = navParams["referrerUrl"]
      }

      // console.log("NAV CALLED", url, state)

      navigate(url, { state })
    }

    return (
      <ModalContext.Consumer>
        {(modalContext) => {
          if (!modalContext) {
            console.log("debug: ModalContext is not yet defined, returning null")
            return null
          }

          const { showModal, hideModal } = modalContext

          return (
            <NotificationContext.Consumer>
              {(notifContext) => {
                if (!notifContext) {
                  console.log("debug: NotificationContext is not yet defined, returning null")
                  return null
                }

                const { success, failed } = notifContext

                return (
                  <Component
                    {...props}
                    RightsManager={new RightsManager()}
                    DebugManager={(className) => new DebugManager(className)}
                    i18n={i18n}
                    t={t}
                    changeLanguage={changeLanguage}
                    router={{ nav, location, params }}
                    showModal={showModal}
                    hideModal={hideModal}
                    notif={{ success, failed }}
                  />
                )
              }}
            </NotificationContext.Consumer>
          )
        }}
      </ModalContext.Consumer>
    )
  }
}

export default withHooks
